import * as React from 'react'

import { classList } from 'react-classlist-helper'

interface IGroupLabelProps {
  icon?: React.ReactNode
  /** Overrides the label text's colour - e.g. to mute an inactive band. */
  className?: string
  children: React.ReactNode
}

export default function GroupLabel({
  icon,
  className,
  children,
}: IGroupLabelProps): React.ReactElement {
  return (
    <span className="tw:flex tw:min-w-0 tw:items-center tw:gap-2">
      {icon && (
        <span className="tw:flex tw:shrink-0 tw:items-center">{icon}</span>
      )}
      <span
        className={classList({
          'tw:truncate tw:text-label-lg': true,
          'tw:text-foreground': !className,
          [className || '']: !!className,
        })}
      >
        {children}
      </span>
    </span>
  )
}
